import EliminatoriaCompartida from "./EliminatoriaCompartida";

const Semis = () => (
  <EliminatoriaCompartida
    fase="semifinal"
    titulo="Predicciones Semifinales"
    endpoint="/semifinal/partidos"
    fechaPrimerPartido="2026-07-14T18:00:00"
  />
);

export default Semis;
